// src/components/BoardOfEd/components/Program2100.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2100_CONFIG = {
  fullName: "OPERATIONS & MAINTENANCE",
  docId: "2100",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsSupervision",
      label: "Positions – Supervision",
      valueType: "count",
      sources: [{ block: "Positions", key: "Supervision" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsCustodians",
      label: "Positions – Custodians",
      valueType: "count",
      sources: [{ block: "Positions", key: "Custodians" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsMaintainers",
      label: "Positions – Maintainers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Maintainers" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesSupervision",
      label: "Salaries – Supervision",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Supervision" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesCustodial",
      label: "Salaries – Custodial",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Custodial" },
        { block: "Salaries", key: "Custodians" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesCustodialPartTime",
      label: "Salaries – Custodial (Part-Time)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Custodial - Part Time" },
        { block: "Salaries", key: "Custocial - Part Time" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesMaintenance",
      label: "Salaries – Maintenance",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Maintenance" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSummerPartTime",
      label: "Salaries – Summer / Part-Time",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Summer / Part Time" },
        { block: "Salaries", key: "Summer/Part Time" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesCoverage",
      label: "Salaries – Coverage",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Coverage" },
        { block: "Purchased Services", key: "Coverage" }, // early-year placement
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "psTestingInspection",
      label: "Testing / Inspection / Monitor",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Testing / Inspection / Monitor" },
        {
          block: "Purchased Services",
          key: "Testing/Inspection/Monitor",
        },
      ],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "psContractedByBuilding",
      label: "Contracted Svcs. by Building",
      valueType: "currency",
      sources: [
        {
          block: "Purchased Services",
          key: "Contracted Services by Building",
        },
        {
          block: "Purchased Services",
          key: "Contracted Svcs. - By Building",
        },
      ],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "psContractedSystemwide",
      label: "Contracted Svcs. Systemwide",
      valueType: "currency",
      sources: [
        {
          block: "Purchased Services",
          key: "Contracted Services Systemwide",
        },
        {
          block: "Purchased Services",
          key: "Contracted Svcs. - Systemwide",
        },
      ],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "psMaintenanceProjectsContr",
      label: "Maintenance Projects (Contractor)",
      valueType: "currency",
      sources: [
        {
          block: "Purchased Services",
          key: "Maintenance Projects Contractor",
        },
        {
          block: "Purchased Services",
          key: "Maintenance Projects, Contr.",
        },
      ],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "psInsurancePropertyBoiler",
      label: "Insurance (Property / Boiler)",
      valueType: "currency",
      sources: [
        {
          block: "Purchased Services",
          key: "Insurance - Property / Boiler",
        },
        {
          block: "Purchased Services",
          key: "Insurance - Property / Broiler",
        },
      ],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "psVehicleMaintenance",
      label: "Vehicle Maintenance",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Vehicle Maintenance" }],
      group: "purchasedServices",
      defaultVisible: false,
    },
    {
      key: "psLeasedOfficeSpace",
      label: "Leased Office Space",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Leased Office Space" }],
      group: "purchasedServices",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "suppliesCustodial",
      label: "Custodial Supplies",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Custodial Supplies" },
        { block: "Supplies / Materials", key: "CustodIAL Supplies" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "suppliesMaintenance",
      label: "Maintenance Supplies",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Maintenance Supplies" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "suppliesMaintenanceProjects",
      label: "Maintenance Projects (Supplies)",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Maintenance Projects Supl" },
        { block: "Supplies / Materials", key: "Maintenance Projects, Supl." },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "suppliesTechnologySoftware",
      label: "Technology Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology Software " }, // trailing space
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "otherTravelReimbursement",
      label: "Travel Reimbursement",
      valueType: "currency",
      sources: [{ block: "Other", key: "Travel Reimbursement" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherSpecialProjects",
      label: "Special Projects",
      valueType: "currency",
      sources: [{ block: "Other", key: "Special Projects" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherEastburyMaintenance",
      label: "Eastbury Maintenance",
      valueType: "currency",
      sources: [{ block: "Other", key: "Eastbury Maintenance" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "otherDuesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues / Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues and Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },

    // EQUIPMENT
    {
      key: "equipmentNew",
      label: "New",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "New" }],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipmentReplacement",
      label: "Replacement",
      valueType: "currency",
      sources: [{ block: "Equipment", key: "Replacement" }],
      group: "equipment",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsSupervision",
        "positionsSecretarial",
        "positionsCustodians",
        "positionsMaintainers",

        // Salaries
        "salariesSupervision",
        "salariesSecretarial",
        "salariesCustodial",
        "salariesCustodialPartTime",
        "salariesMaintenance",
        "salariesSummerPartTime",
        "salariesCoverage",

        // Purchased Services
        "psTestingInspection",
        "psContractedByBuilding",
        "psContractedSystemwide",
        "psMaintenanceProjectsContr",
        "psInsurancePropertyBoiler",
        "psVehicleMaintenance",
        "psLeasedOfficeSpace",

        // Supplies / Materials
        "suppliesCustodial",
        "suppliesMaintenance",
        "suppliesMaintenanceProjects",
        "suppliesTechnologySoftware",

        // Other
        "otherTravelReimbursement",
        "otherSpecialProjects",
        "otherEastburyMaintenance",
        "otherDuesFees",

        // Equipment
        "equipmentNew",
        "equipmentReplacement",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsSupervision: { minWidth: "110px" },
        positionsSecretarial: { minWidth: "110px" },
        positionsCustodians: { minWidth: "110px" },
        positionsMaintainers: { minWidth: "110px" },

        // Salaries
        salariesSupervision: { minWidth: "120px" },
        salariesSecretarial: { minWidth: "120px" },
        salariesCustodial: { minWidth: "120px" },
        salariesCustodialPartTime: { minWidth: "160px" },
        salariesMaintenance: { minWidth: "130px" },
        salariesSummerPartTime: { minWidth: "150px" },
        salariesCoverage: { minWidth: "120px" },

        // Purchased Services
        psTestingInspection: { minWidth: "160px" },
        psContractedByBuilding: { minWidth: "130px" },
        psContractedSystemwide: { minWidth: "130px" },
        psMaintenanceProjectsContr: { minWidth: "170px" },
        psInsurancePropertyBoiler: { minWidth: "170px" },
        psVehicleMaintenance: { minWidth: "150px" },
        psLeasedOfficeSpace: { minWidth: "140px" },

        // Supplies / Materials
        suppliesCustodial: { minWidth: "140px" },
        suppliesMaintenance: { minWidth: "150px" },
        suppliesMaintenanceProjects: { minWidth: "190px" },
        suppliesTechnologySoftware: { minWidth: "170px" },

        // Other
        otherTravelReimbursement: { minWidth: "150px" },
        otherSpecialProjects: { minWidth: "140px" },
        otherEastburyMaintenance: { minWidth: "170px" },
        otherDuesFees: { minWidth: "120px" },

        // Equipment
        equipmentNew: { minWidth: "110px" },
        equipmentReplacement: { minWidth: "130px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsSupervision",
        "positionsSecretarial",
        "positionsCustodians",
        "positionsMaintainers",

        // Salaries
        "salariesSupervision",
        "salariesSecretarial",
        "salariesCustodial",
        "salariesCustodialPartTime",
        "salariesMaintenance",
        "salariesSummerPartTime",
        "salariesCoverage",

        // Purchased Services
        "psTestingInspection",
        "psContractedByBuilding",
        "psContractedSystemwide",
        "psMaintenanceProjectsContr",
        "psInsurancePropertyBoiler",
        "psVehicleMaintenance",
        "psLeasedOfficeSpace",

        // Supplies / Materials
        "suppliesCustodial",
        "suppliesMaintenance",
        "suppliesMaintenanceProjects",
        "suppliesTechnologySoftware",

        // Other
        "otherTravelReimbursement",
        "otherSpecialProjects",
        "otherEastburyMaintenance",
        "otherDuesFees",

        // Equipment
        "equipmentNew",
        "equipmentReplacement",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsSupervision: { minWidth: "110px" },
        positionsSecretarial: { minWidth: "110px" },
        positionsCustodians: { minWidth: "110px" },
        positionsMaintainers: { minWidth: "110px" },

        // Salaries
        salariesSupervision: { minWidth: "120px" },
        salariesSecretarial: { minWidth: "120px" },
        salariesCustodial: { minWidth: "120px" },
        salariesCustodialPartTime: { minWidth: "160px" },
        salariesMaintenance: { minWidth: "130px" },
        salariesSummerPartTime: { minWidth: "150px" },
        salariesCoverage: { minWidth: "120px" },

        // Purchased Services
        psTestingInspection: { minWidth: "160px" },
        psContractedByBuilding: { minWidth: "130px" },
        psContractedSystemwide: { minWidth: "130px" },
        psMaintenanceProjectsContr: { minWidth: "170px" },
        psInsurancePropertyBoiler: { minWidth: "170px" },
        psVehicleMaintenance: { minWidth: "150px" },
        psLeasedOfficeSpace: { minWidth: "140px" },

        // Supplies / Materials
        suppliesCustodial: { minWidth: "140px" },
        suppliesMaintenance: { minWidth: "150px" },
        suppliesMaintenanceProjects: { minWidth: "190px" },
        suppliesTechnologySoftware: { minWidth: "170px" },

        // Other
        otherTravelReimbursement: { minWidth: "150px" },
        otherSpecialProjects: { minWidth: "140px" },
        otherEastburyMaintenance: { minWidth: "170px" },
        otherDuesFees: { minWidth: "120px" },

        // Equipment
        equipmentNew: { minWidth: "110px" },
        equipmentReplacement: { minWidth: "130px" },
      },
    },
  ],
};

export function Program2100(props) {
  return (
    <ProgramBudget programId="2100" config={PROGRAM_2100_CONFIG} {...props} />
  );
}
